module.exports = "/images/email.svg?2185626eb663bae48499c3d4a838fcb1";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icons/email.svg
// module id = 3plx
// module chunks = 0 1